{
  "common": {
    "loading": "Loading…",
    "yes": "Yes",
    "no": "No",
    "save": "Save",
    "reset": "Reset",
    "cancel": "Cancel",
    "retry": "Retry",
    "done": "Done",
    "unlimited": "Unlimited"
  },
  "auth": {
    "agree": "I agree to",
    "createAccount": "Create account",
    "createNewAccount": "Create New Account",
    "email": "Email",
    "login": "Login",
    "password": "Password",
    "recover_password": "Recover password",
    "sign_up": "Sign Up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset password",
    "welcome_to": "Welcome to",
    "login_to_client": "Sign in to {clientName}",
    "login_to_labvigator": "Sign in to Labvigator",
    "login_via_labvigator": "Signing in via Labvigator",
    "proceed_to_login": "Proceed to login",
    "powered_by_pathways": "Powered by Pathways Solutions",
    "client_logo_alt": "{clientName} logo",
    "labvigator_logo_alt": "Labvigator logo",
    "login_error": "Login Error",
    "redirecting_to_login": "Redirecting to login..."
  },
  "error": {
    "no_data": "No data available",
    "error": "Error: {errorMessage}",
    "no_lab_report": "No lab report available",
    "empty_pdf": "The PDF file is empty or invalid",
    "forbidden": "Access forbidden",
    "failed_to_load_system_statistics": "Failed to load system statistics",
    "failed_to_load_client_usage": "Failed to load report token usage",
    "failed_to_save_usage": "Failed to save report token usage",
    "failed_to_reinitialize_usage": "Failed to reinitialize report token usage"
  },
  "404": {
    "title": "This page’s gone fishing.",
    "text": "If you feel that it’s not right, please send us a message at ",
    "back_button": "Back to dashboard"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "menu": {
    "auth": "Auth",
    "buttons": "Buttons",
    "timelines": "Timelines",
    "test": "DEV Test",
    "clients": "Lab Clients",
    "features": "Features",
    "subscription-plans": "Subscription Plans",
    "dashboard": "Dashboard",
    "billing": "Billing",
    "login": "Login",
    "preferences": "Account preferences",
    "payments": "Payments",
    "settings": "Application settings",
    "pricing-plans": "Pricing plans",
    "payment-methods": "Payment methods",
    "signup": "Signup",
    "recover-password": "Recover password",
    "recover-password-email": "Recover password email",
    "404": "404",
    "error": "Error",
    "faq": "FAQ",
    "users": "Users",
    "user-groups": "User Groups",
    "projects": "Projects",
    "admin": "Admin",
    "home": "Home Page",
    "reports": "Lab Reports",
    "admin-settings": "Settings",
    "profile": "Profile",
    "subscriptions": "Subscriptions",
    "token-usage": "Report Token",
    "token-usage-overview": "Token Usage Overview",
    "analytics": "Analytics",
    "platform-analytics": "Platform Analytics"
  },
  "menuHeaders": {
    "client-admin": "Client Admin",
    "pw-admin": "PW Admin",
    "developer": "Developer"
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic"
  },
  "user": {
    "language": "Change language",
    "logout": "Logout",
    "profile": "Profile",
    "settings": "Settings",
    "billing": "Billing",
    "faq": "FAQ",
    "helpAndSupport": "Help & support",
    "projects": "Projects",
    "account": "Account",
    "preferences": "Preferences",
    "explore": "Explore",
    "accounts": "Accounts",
    "darkMode": "Dark Mode"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "Help & support",
  "aboutVuesticAdmin": "About Vuestic Admin",
  "search": {
    "placeholder": "Search..."
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  },
  "vuestic": {
    "search": "Search",
    "noOptions": "Items not found",
    "ok": "OK",
    "cancel": "Cancel",
    "uploadFile": "Upload file",
    "undo": "Undo",
    "dropzone": "Drop files here to upload",
    "fileDeleted": "File deleted",
    "closeAlert": "close alert",
    "backToTop": "back to top",
    "toggleDropdown": "toggle dropdown",
    "carousel": "carousel",
    "goPreviousSlide": "go previous slide",
    "goNextSlide": "go next slide",
    "goSlide": "go slide {index}",
    "slideOf": "slide {index} of {length}",
    "close": "close",
    "openColorPicker": "open color picker",
    "colorSelection": "color selection",
    "colorName": "color {color}",
    "decreaseCounter": "decrease counter",
    "increaseCounter": "increase counter",
    "selectAllRows": "select all rows",
    "sortColumnBy": "sort column by {name}",
    "selectRowByIndex": "select row {index}",
    "resetDate": "reset date",
    "nextPeriod": "next period",
    "switchView": "switch view",
    "previousPeriod": "previous period",
    "removeFile": "remove file",
    "reset": "reset",
    "pagination": "pagination",
    "goToTheFirstPage": "go to the first page",
    "goToPreviousPage": "go to the previous page",
    "goToSpecificPage": "go to the {page} page",
    "goToSpecificPageInput": "enter the page number to go",
    "goNextPage": "go next page",
    "goLastPage": "go last page",
    "currentRating": "current rating {value} of {max}",
    "voteRating": "vote rating {value} of {max}",
    "optionsFilter": "options filter",
    "splitPanels": "split panels",
    "movePaginationLeft": "move pagination left",
    "movePaginationRight": "move pagination right",
    "resetTime": "reset time",
    "closeToast": "close toast",
    "selectedOption": "Selected option",
    "noSelectedOption": "Option is not selected",
    "breadcrumbs": "breadcrumbs",
    "counterValue": "counter value",
    "selectedDate": "selected date",
    "selectedTime": "selected time",
    "progressState": "progress state",
    "color": "color",
    "next": "Next",
    "back": "Previous",
    "finish": "Finish",
    "step": "step",
    "progress": "progress",
    "loading": "Loading",
    "sliderValue": "Current slider value is {value}",
    "switch": "Switch",
    "inputField": "Input field",
    "fileTypeIncorrect": "File type is incorrect",
    "select": "Select an option"
  },
  "action": {
    "success": "{action} action performed successfully!",
    "error": "{action} action failed!",
    "download_pdf": "Download PDF",
    "previous": "Previous",
    "next": "Next",
    "edit": "Edit",
    "refresh": "Refresh",
    "save": "Save",
    "cancel": "Cancel"
  },
  "billing": {
    "nextPlanMismatch": "The next subscription '{nextPlanName}' does not match the chosen plan '{chosenPlanName}'. Please contact the system administrator to update the next subscription."
  },
  "token_usage": {
    "title": "Report Token Management",
    "subtitle": "Monitor and manage lab report access token quotas",
    "all_clients_title": "All Clients Token Usage",
    "all_clients_subtitle": "System-wide token usage statistics and management",
    "edit_form_placeholder": "Edit form will be implemented here",
    "system_statistics": "System Statistics",
    "total_active_tokens": "Total Active Report Tokens",
    "total_expired_tokens": "Total Expired Report Tokens",
    "total_clients_with_tokens": "Total Clients with Report Tokens",
    "average_tokens_per_client": "Average Report Tokens per Client",
    "client_selection": "Client Selection",
    "select_client": "Select a client to view report token usage",
    "client_details": "Report Token Details",
    "client_code": "Client Code",
    "usage": "Usage",
    "can_grant": "Can Grant",
    "total_limit": "Total Limit",
    "tokens_used": "Report Tokens Consumed",
    "tokens_remaining": "Report Tokens Remaining",
    "usage_progress": "Usage Progress",
    "subscription_period": "Subscription Period",
    "can_grant_tokens": "Can Grant Report Tokens",
    "monthly_quotas": "Monthly Quotas",
    "monthly_quotas_explanation": "Each month has a quota of tokens. When a report is accessed, a token is created and consumed from the oldest available quota (FIFO). The 'Consumed' column shows tokens depleted from each quota, while 'Created' shows tokens generated in that calendar month.",
    "month": "Month",
    "tokens_granted": "Report Tokens Granted",
    "tokens_created": "Report Tokens Created",
    "tokens_created_tooltip": "Number of new report access tokens created in this calendar month",
    "tokens_consumed": "Report Tokens Consumed",
    "tokens_consumed_tooltip": "Number of tokens consumed from this quota (oldest quotas are depleted first)",
    "remaining": "Remaining",
    "effective_date": "Effective Date",
    "expiry_date": "Expiry Date",
    "status": "Status",
    "active": "Active",
    "pending": "Pending",
    "expired": "Expired",
    "exhausted": "Exhausted",
    "no_data": "No Data Available",
    "no_data_description": "No report token usage data found for the selected client.",
    "edit_usage": "Edit Report Token Usage",
    "reinitialize": "Reinitialize",
    "reinitialize_confirmation": "Reinitialize Report Token Usage",
    "reinitialize_warning": "Warning: This action will replace current report token usage data",
    "reinitialize_description": "This will mark the current usage as replaced and create new usage based on the current subscription.",
    "reinitialize_confirm_text": "Are you sure you want to reinitialize report token usage for this client?",
    "usage_updated_successfully": "Report token usage updated successfully",
    "usage_reinitialized_successfully": "Report token usage reinitialized successfully",
    "basic_information": "Basic Information",
    "subscription_id": "Subscription ID",
    "start_date": "Start Date",
    "end_date": "End Date",
    "monthly_token_limit": "Monthly Token Limit",
    "add_quota": "Add Quota",
    "no_quotas": "No monthly quotas defined",
    "quota_number": "Quota #{number}",
    "tokens_used_list": "Tokens Used List",
    "tokens_used_placeholder": "Enter token IDs, one per line",
    "tokens_used_help": "Enter each token ID on a separate line",
    "validation_errors": "Validation Errors",
    "token_terminology_title": "Understanding Token Metrics",
    "token_terminology_created": "Token Creation: When a doctor accesses a patient report for the first time, a new report access token is created. This is counted in the month when the access occurred.",
    "token_terminology_consumed": "Token Consumption: When a token is created, it consumes from your oldest available quota first (FIFO - First In, First Out). This ensures older quotas are used before expiring.",
    "token_terminology_summary": "Token Usage: The overall metric combining both creation and consumption. The 'Consumed' count per quota may differ from 'Created' because tokens are always consumed from the earliest quota with remaining balance."
  },
  "validation": {
    "required": "This field is required",
    "min_value": "Value must be at least {min}",
    "max_tokens_used": "Tokens used cannot exceed {max}",
    "end_date_after_start": "End date must be after start date",
    "expiry_after_effective": "Expiry date must be after effective date",
    "client_code_required": "Client code is required",
    "subscription_id_required": "Subscription ID is required",
    "start_date_required": "Start date is required",
    "end_date_required": "End date is required",
    "token_limit_required": "Token limit must be greater than 0",
    "quota_month_required": "Month is required for quota {index}",
    "quota_subscription_required": "Subscription ID is required for quota {index}",
    "quota_tokens_granted_required": "Tokens granted must be greater than 0 for quota {index}",
    "quota_tokens_used_invalid": "Tokens used cannot be negative for quota {index}",
    "quota_tokens_used_exceeded": "Tokens used cannot exceed tokens granted for quota {index}",
    "quota_effective_date_required": "Effective date is required for quota {index}",
    "quota_expiry_date_required": "Expiry date is required for quota {index}",
    "quota_expiry_after_effective": "Expiry date must be after effective date for quota {index}"
  },
  "label": {
    "page": "Page"
  },
  "clientSettings": {
    "title": "Client Settings",
    "description": "Configure your lab settings and preferences",
    "accessDenied": "You don't have permission to access client settings.",
    "brandingFeatureRequired": "Access to theme and homepage customization requires the branding feature in your subscription plan.",
    "reportSearch": {
      "title": "Report Search",
      "description": "Configure the default date range used when users open the lab report search page.",
      "defaultDateRangeDays": "Default date range in days",
      "defaultDateRangeDaysPlaceholder": "Enter the default number of days",
      "defaultDateRangeHelp": "This controls the initial date range on the lab report search page and when filters are reset.",
      "doctorOverrideHelp": "Doctors and other users on Premium or above can override this in their own preferences.",
      "upgradeRequired": "This setting requires the Plus plan or above.",
      "saveSuccess": "Report search defaults saved successfully!",
      "saveError": "Failed to save report search defaults. Please try again.",
      "fetchError": "Failed to load report search defaults. Please try again.",
      "accessDenied": "You don't have permission to modify report search defaults for this lab.",
      "validation": {
        "integerRange": "Enter a whole number between {min} and {max}."
      }
    },
    "labInfo": {
      "title": "Lab Info",
      "description": "Manage your laboratory information and contact details",
      "basicInformation": "Basic Information",
      "contactInformation": "Contact Information",
      "addressInformation": "Address Information",
      "labName": "Lab Name",
      "labNamePlaceholder": "Enter your laboratory name",
      "labCode": "Lab Code",
      "labCodePlaceholder": "Lab identifier code",
      "contactPerson": "Contact Person",
      "contactPersonPlaceholder": "Enter primary contact person name",
      "contactEmail": "Contact Email",
      "contactEmailPlaceholder": "Enter contact email address",
      "contactPhone": "Contact Phone",
      "contactPhonePlaceholder": "Enter contact phone number",
      "address": "Address",
      "addressPlaceholder": "Enter your laboratory address",
      "city": "City",
      "cityPlaceholder": "Enter city",
      "state": "State/Province",
      "statePlaceholder": "Enter state or province",
      "postalCode": "Postal Code",
      "postalCodePlaceholder": "Enter postal code",
      "saveSuccess": "Lab information saved successfully!",
      "saveError": "Failed to save lab information. Please try again."
    },
    "themeSettings": {
      "title": "Theme",
      "description": "Customize the visual appearance of your lab portal with custom colors and logo",
      "logoSection": "Logo",
      "faviconSection": "Favicon",
      "colorPalette": "Color Palette",
      "typographyLayout": "Typography & Layout",
      "appearanceSettings": "Appearance Settings",
      "primaryColor": "Primary Color",
      "primaryColorHelp": "This color will be used for main buttons, highlights, and active states",
      "secondaryColor": "Secondary Color",
      "secondaryColorHelp": "This color will be used for secondary buttons and accent elements",
      "accentColor": "Accent Color",
      "accentColorHelp": "This color will be used for highlights, links, and accent elements",
      "successColor": "Success Color",
      "successColorHelp": "This color will be used for success messages and positive actions",
      "warningColor": "Warning Color",
      "warningColorHelp": "This color will be used for warning messages and caution alerts",
      "errorColor": "Error Color",
      "errorColorHelp": "This color will be used for error messages and destructive actions",
      "fontFamily": "Font Family",
      "fontFamilyHelp": "Choose the font family for your lab portal text",
      "fontOptions": {
        "default": "Default System Font"
      },
      "fontSize": "Font Size",
      "fontSizeHelp": "Adjust the base font size for better readability",
      "fontSizeOptions": {
        "small": "Small (14px)",
        "medium": "Medium (16px)",
        "large": "Large (18px)"
      },
      "borderRadius": "Border Radius",
      "borderRadiusHelp": "Control the roundness of buttons, cards, and other elements",
      "borderRadiusOptions": {
        "none": "None (Sharp corners)",
        "small": "Small (4px)",
        "medium": "Medium (8px)",
        "large": "Large (16px)",
        "full": "Full (Rounded)"
      },
      "darkMode": "Dark Mode",
      "darkModeHelp": "Enable dark mode for a more comfortable viewing experience in low-light conditions",
      "preview": "Preview",
      "previewPrimary": "Primary Button",
      "previewSecondary": "Secondary Button",
      "previewAccent": "Accent Link",
      "previewSuccess": "Success",
      "previewWarning": "Warning",
      "previewError": "Error",
      "previewCheckbox": "Sample checkbox with custom colors",
      "previewHeading": "Sample Heading Text",
      "previewText": "This is a sample paragraph text to demonstrate how your chosen typography and colors will look in your lab portal.",
      "saveSuccess": "Theme settings saved successfully!",
      "saveError": "Failed to save theme settings. Please try again.",
      "logoUploadSuccess": "Logo uploaded successfully!",
      "logoRemoveSuccess": "Logo removed successfully!",
      "faviconUploadSuccess": "Favicon uploaded successfully!",
      "faviconRemoveSuccess": "Favicon removed successfully!",
      "accessDenied": "You don't have permission to modify theme settings for this lab."
    },
    "homePage": {
      "title": "Home Page",
      "description": "Customize your lab's home page content with rich text editing capabilities",
      "pageTitle": "Page Title",
      "titleLabel": "Page Title",
      "titlePlaceholder": "Enter the title for your home page",
      "contentSection": "Page Content",
      "publishingSection": "Publishing Options",
      "publishLabel": "Publish this page",
      "publishedAtLabel": "Publish Date",
      "publishedTimeLabel": "Publish Time",
      "preview": "Preview",
      "previewInNewTab": "Preview in New Tab",
      "untitledPreview": "Untitled Page",
      "noContentPreview": "No content available",
      "publishedStatus": "Published on",
      "draftStatus": "Draft - Not published",
      "now": "now",
      "saveSuccess": "Home page content saved successfully!",
      "saveError": "Failed to save home page content. Please try again.",
      "fetchError": "Failed to load home page content. Please try again.",
      "accessDenied": "You don't have permission to manage the home page for this lab."
    }
  },
  "preferences": {
    "reportSearch": {
      "title": "Default report search range",
      "description": "Choose whether to use your own default date range when you open the report search page.",
      "shortDescription": "Set the default days used when this page opens.",
      "noClientContext": "Select a client context to manage this preference.",
      "upgradeRequired": "Your current plan uses the client default instead. The current effective default is {days} days.",
      "useOwnDefault": "Use my own default report search range",
      "useOwnDefaultShort": "Use my own default",
      "defaultDateRangeDays": "My default date range in days",
      "defaultDateRangeDaysPlaceholder": "Enter your preferred number of days",
      "buttonDefault": "Default: {days}d",
      "buttonCustom": "My default: {days}d",
      "overrideHelp": "This value takes precedence over the client-wide default when you load or reset report search filters.",
      "overrideHelpShort": "Your saved value will be used when this page opens or resets.",
      "inheritHelp": "You are currently inheriting the client default. The effective default is {days} days.",
      "saveSuccess": "Your report search preference was saved successfully.",
      "saveError": "Failed to save your report search preference. Please try again.",
      "validation": {
        "integerRange": "Enter a whole number between {min} and {max}."
      }
    }
  },
  "clientHome": {
    "publishedOn": "Published on",
    "defaultWelcome": "Welcome to Your Lab Portal",
    "defaultMessage": "This is your lab's home page. Lab administrators can customize this content to provide information, announcements, and resources for lab users.",
    "customizeHomePage": "Customize Home Page",
    "fetchError": "Failed to load home page content. Please try again.",
    "draftMode": "Draft Mode - Only visible to administrators"
  },
  "errors": {
    "error": "Error",
    "clientNotFound": "Client not found",
    "failedToLoadClient": "Failed to load client information",
    "accessDenied": "Access Denied"
  },
  "success": {
    "success": "Success"
  },
  "batchUserImport": {
    "title": "Batch User Import",
    "dropZone": {
      "message": "Drag and drop your Excel file here, or click to browse"
    },
    "errors": {
      "invalidFileType": "Please drop a valid Excel file (.xlsx or .xls)",
      "noDataRows": "No data rows found in the Excel file",
      "parseError": "Failed to parse file"
    },
    "limitExceeded": "Active user limit would be exceeded!",
    "limitInfo": {
      "activeUsers": "Active users",
      "current": "Current",
      "max": "Max",
      "after": "After import"
    },
    "summary": {
      "toCreate": "to create",
      "toUpdate": "to update",
      "unchanged": "unchanged",
      "errors": "errors"
    },
    "preview": {
      "newUsers": "New Users to Create",
      "usersToUpdate": "Users to Update",
      "rowsWithErrors": "Rows with Errors"
    },
    "columns": {
      "email": "Email",
      "fullName": "Name",
      "roles": "Roles",
      "status": "Status",
      "changedFields": "Changed Fields",
      "error": "Error"
    },
    "result": {
      "success": "Import completed successfully!",
      "withErrors": "Import completed with errors",
      "created": "Created",
      "updated": "Updated",
      "skipped": "Skipped",
      "errors": "Errors"
    },
    "largeImportWarning": {
      "title": "Large Import Warning",
      "message": "You are about to process {count} users. Are you sure?",
      "confirm": "Confirm Import"
    },
    "importButton": "Import {count} Users"
  },
  "invoice": {
    "Invoice": "Invoice",
    "Invoice No": "Invoice No",
    "Issue Date": "Issue Date",
    "Client Information": "Client Information",
    "Name": "Name",
    "Client Code": "Client Code",
    "Contact Person": "Contact Person",
    "Contact Number": "Contact Number",
    "Email": "Email",
    "Address": "Address",
    "Subscription Details": "Subscription Details",
    "Product/Services": "Product/Services",
    "Product / Service Description": "Product / Service Description",
    "Period": "Period",
    "Unit Price": "Unit Price",
    "Qty": "Qty",
    "Total": "Total",
    "Includes": "Includes",
    "Subscription Plan": "Subscription Plan",
    "Plan": "Plan",
    "Recurring Type": "Recurring Type",
    "Total Amount": "Total Amount",
    "Subtotal": "Subtotal",
    "Discount": "Discount",
    "Remarks": "Remarks",
    "Remarks / Payment Instructions": "Remarks / Payment Instructions",
    "PAYMENT METHODS": "PAYMENT METHODS",
    "PLEASE MAKE PAYMENT BY CHEQUE OR TELEGRAPHIC TRANSFER": "PLEASE MAKE PAYMENT BY CHEQUE OR TELEGRAPHIC TRANSFER",
    "CHEQUE SHOULD BE CROSSED AND MADE PAYABLE TO": "CHEQUE SHOULD BE CROSSED AND MADE PAYABLE TO",
    "NAME OF BANK": "NAME OF BANK",
    "THE HONGKONG AND SHANGHAI BANKING CORPORATION LIMITED": "THE HONGKONG AND SHANGHAI BANKING CORPORATION LIMITED",
    "ACCOUNT NO": "ACCOUNT NO",
    "1 QUEENS ROAD CENTRAL": "1 QUEEN'S ROAD CENTRAL",
    "SWIFT CODE": "SWIFT CODE",
    "A/C NAME": "A/C NAME",
    "PATHWAYS SOLUTIONS LIMITED": "PATHWAYS SOLUTIONS LIMITED",
    "AFTER PAYMENT": "AFTER PAYMENT",
    "Please upload your payment proof to the Labvigator portal at": "Please upload your payment proof to the Labvigator portal at",
    "for verification and activation of your subscription": "for verification and activation of your subscription"
  },
  "analytics": {
    "title": "Analytics",
    "subtitle": "Monitor user engagement and report access metrics",
    "platform_title": "Platform Analytics",
    "platform_subtitle": "Monitor analytics across all clients",
    "time_period": "Time Period",
    "select_client": "Select Client",
    "view_all_clients": "View All Clients",
    "viewing_client": "Viewing analytics for {clientName}",
    "no_data": "No Analytics Data",
    "no_data_available": "No data available",
    "no_data_description": "There is no analytics data available for the selected period.",
    "no_data_for_leaderboard": "No data available for the leaderboard",
    "no_users": "No users found",
    "active_users": "Active Users",
    "total_searches": "Total Searches",
    "report_views": "Report Views",
    "token_usage": "Token Usage",
    "token_usage_tooltip": "Total report access tokens created in this period. A token is created when a doctor first accesses a patient report.",
    "tokens_created": "Tokens Created",
    "tokens_created_description": "New report access tokens generated",
    "tokens_consumed": "Tokens Consumed",
    "tokens_consumed_description": "Tokens depleted from monthly quotas",
    "total_downloads": "Downloads",
    "user_activity_trend": "User Activity Trend",
    "report_activity_trend": "Report Activity Trend",
    "peak_usage_days": "Peak Usage by Day",
    "peak_usage_hours": "Peak Usage Hours",
    "platform_peak_hours": "Platform-wide Peak Hours",
    "top_users": "Top Users",
    "feature_usage": "Feature Usage",
    "unique_users": "unique users",
    "active_users_list": "Active Users",
    "inactive_users_list": "Inactive Users",
    "active_users_hint": "Users active within the last 7 days, sorted by most recent activity first. Showing top 20.",
    "inactive_users_hint": "Users with no activity in the last 7 days, sorted by longest inactive first. Showing top 20.",
    "user": "User",
    "last_active": "Last Active",
    "sessions": "Sessions",
    "events": "Events",
    "days_inactive": "Days Inactive",
    "today": "Today",
    "yesterday": "Yesterday",
    "days_ago": "days ago",
    "searches": "Searches",
    "views": "Views",
    "page_views": "Page Views",
    "downloads": "Downloads",
    "activities": "activities",
    "show_all": "Show all",
    "more": "more",
    "vs_previous_period": "vs previous period",
    "usage": "Usage",
    "low": "Low",
    "high": "High",
    "export": "Export",
    "export_format": "Export Format",
    "export_csv": "CSV",
    "export_excel": "Excel",
    "export_pdf": "PDF",
    "export_success": "Analytics data exported successfully",
    "export_error": "Failed to export analytics data",
    "include_sections": "Include Sections",
    "section_summary": "Summary",
    "section_users": "User Metrics",
    "section_reports": "Report Activity",
    "section_features": "Feature Usage",
    "upgrade_for_more_formats": "Upgrade to Advanced Analytics for more export formats",
    "upgrade_now": "Upgrade Now",
    "unlock_advanced": "Unlock Advanced Analytics",
    "advanced_features_description": "Get unlimited history, custom reports, benchmarking, alerts, and more export options.",
    "total_clients": "Total Clients",
    "total_active_users": "Total Active Users",
    "total_reports_accessed": "Reports Viewed",
    "reports_accessed": "Reports Viewed",
    "total_tokens_created": "Tokens Created",
    "total_tokens_created_tooltip": "Total number of new report access tokens created",
    "client_comparison": "Client Comparison",
    "client": "Client",
    "actions": "Actions",
    "view_details": "View Details",
    "platform_user_trend": "Platform User Trend",
    "platform_report_trend": "Platform Report Views Trend",
    "period": {
      "last_7_days": "Last 7 Days",
      "last_30_days": "Last 30 Days",
      "last_90_days": "Last 90 Days",
      "last_12_months": "Last 12 Months"
    },
    "role_filter": {
      "all": "All Users",
      "doctor": "Doctors",
      "admin": "Admins"
    },
    "days": {
      "sunday": "Sun",
      "monday": "Mon",
      "tuesday": "Tue",
      "wednesday": "Wed",
      "thursday": "Thu",
      "friday": "Fri",
      "saturday": "Sat"
    },
    "error": {
      "fetch_failed": "Failed to fetch analytics data. Please try again later."
    }
  }
}